<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps<{ error: NuxtError }>()
</script>

<template>
  <div>
    <h1>{{ error.status }} {{ error.statusText }}</h1>
  </div>
</template>
